import type {AgeAuthQueryVariables} from '../../graphql/generated/types';
import {ADAPTER_QUERY_KEY_PREFIX} from '../constant';

/**
 * User 도메인 Query Key 관리
 */
export const USER_QUERY_KEY_MAP = {
  /**
   * 연령 인증 정보 조회
   * Origin: useAgeAuthQuery
   */
  ageAuth: (variables: AgeAuthQueryVariables) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'ageAuth', variables] as const,
} as const;
